var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-row",
    { staticClass: "mb-4", attrs: { "align-v": "center" } },
    [
      _c("b-col", [
        _c("h1", [
          _vm._v(
            "\n            " +
              _vm._s(_vm.title ? _vm.title : _vm.$route.meta.title) +
              "\n        "
          )
        ]),
        _vm._v(" "),
        !!_vm.$slots.default ? _c("div", [_vm._t("default")], 2) : _vm._e()
      ]),
      _vm._v(" "),
      _c(
        "b-col",
        { staticClass: "d-print-none", attrs: { cols: "auto" } },
        [
          _vm.$listeners["go-back"]
            ? _c(
                "fup-button",
                { attrs: { variant: "light" }, on: { click: _vm.back } },
                [
                  _c("fup-icon", {
                    staticClass: "mr-2",
                    attrs: { weight: "r", name: "long-arrow-left" }
                  }),
                  _vm._v(
                    "\n            " +
                      _vm._s(_vm.backButton ? _vm.backButton : "Назад") +
                      "\n        "
                  )
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm._t("buttons")
        ],
        2
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }